import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Success">
                            <h2>New Layers Of Success With Ecommerce Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>TekRevol utilizes the most modern technology stack and unmatchable development skillset to
                            build ecommerce mobile solutions. Our ecommerce apps, online shopping solutions, and
                            marketplace programs are highly user-centric, growth-driven, scalable, and offer global
                            accessibility.</p>
                        <p>With the right ecommerce development solutions, you can significantly improve your online
                            business ROI, establish brand loyalty and enhance the shopping experience for your
                            users.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;